import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/ebook/page.tsx");
